import request from '@/utils/request'
import { getHeader } from '@/utils/header'

export function importData(data) {
  return new Promise((resolve, reject) => {
    const header = getHeader()
    request({
      url: '/callComponent/upload/assetImport/importData',
      method: 'post',
      data,
      headers: {
        ...header,
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error.response && error.response.data ? error.response.data : error)
    })
  })
}
